import { render, staticRenderFns } from "./reports.show.component.vue?vue&type=template&id=5252c61b&scoped=true&"
import script from "./reports.show.component.vue?vue&type=script&lang=js&"
export * from "./reports.show.component.vue?vue&type=script&lang=js&"
import style0 from "./reports.show.component.vue?vue&type=style&index=0&id=5252c61b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252c61b",
  null
  
)

export default component.exports